/**
     * Decodifica string que contiene referencias a caracteres númericos HTML a su formato original.
     * @param {String} data - Texto codificado con caracteres HTML.
     * @returns {String} Texto en formato original
    */
function htmlDecode(data) {
    var e = document.createElement('textarea');
    e.innerHTML = data;
    return e.childNodes.length === 0 ? "" : e.childNodes[0].nodeValue;
}
export default htmlDecode;